package com.milta.core.localization.translations.pl

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Anuluj",
    confirm = "Potwierdź",
    save = "Zapisz",
    delete = "Usuń",
    back = "Wstecz",
    loading = "Ładowanie…",
    retry = "Spróbuj ponownie",
    creationInProgressDoNotClose = "Trwa tworzenie, nie zamykaj okna",
    processingStepSent = "Dokument wysłany",
    processingStepReading = "Odczyt dokumentu",
    processingStepFinding = "Wyszukiwanie dostaw",
    processingStepChecking = "Weryfikacja adresów",
    processingUsualDuration = "Zwykle od 20 do 40 sekund. Pozostań na tym ekranie, resztą zajmiemy się my.",
    processingLongWait = "Dokument zawiera dużo informacji, analiza trwa nieco dłużej niż zwykle. Wszystko działa, kontynuujemy.",
    processingInProgressSince = "W toku od %1",
    processingFinishedIn = "Ukończono w %1",
    processingDeliveriesFound = "Znaleziono dostaw: %1",
    processingDeliveriesFoundOne = "Znaleziono 1 dostawę",
    processingAddressesChecked = "%1 z %2 adresów",
    addressVerifiedBadge = "✓ Adres zweryfikowany",
    addressNeedsReviewBadge = "⚠ Adres do sprawdzenia",
    addressFoundLine = "Znaleziono: %1",
    language = "Język",
    welcomeTitle = "Witaj w Milta",
    welcomeSubtitle = "Twój inteligentny asystent dostaw",
    alreadyHaveAccount = "Mam już konto",
    createAccount = "Utwórz konto",
    continueWithGoogle = "Kontynuuj z Google",
    continueWithApple = "Kontynuuj z Apple",
    oauthErrorGeneric = "Wystąpił błąd podczas logowania. Spróbuj ponownie.",
    oauthAppleWebComingSoon = "Logowanie przez Apple będzie wkrótce dostępne w wersji internetowej.",
    oauthDriverAccountNotAllowedOnWeb = "Konta kierowców nie mają dostępu do panelu internetowego. Zaloguj się przez aplikację mobilną.",
    oauthAccountNotFoundOnWeb = "Nie znaleziono konta Milta dla tego konta Google.",
    errorOffline = "Brak połączenia z internetem.",
    navTourneesDuJour = "Dzisiejsze trasy",
    navAjouterUneTournee = "Dodaj trasę",
    navHistoriqueDesPreuves = "Historia dostaw",
    navParametres = "Ustawienia",
    sidebarRoleManagerLabel = "Menedżer",
    noDeliveriesYetTitle = "Brak dostaw",
    noDeliveriesYetSubtitle = "Dotknij „Dodaj dostawy”, aby je dodać",
    optimizationUnavailableExplanation = "Czy chcesz utworzyć trasę bez optymalizacji, czy spróbować ponownie?",
    createWithoutOptimizationAction = "Utwórz bez optymalizacji",
    gpsAppSheetTitle = "Wybierz aplikację nawigacyjną",
    addressSearchingLabel = "Wyszukiwanie…",
    clearTimeFieldAction = "Wyczyść",
    clearTimeFieldConfirmTitle = "Wyczyścić godzinę?",
    clearTimeFieldConfirmMessage = "Bieżąca godzina zostanie usunięta. W każdej chwili można ustawić nową.",
    updateRequiredTitle = "Wymagana aktualizacja",
    updateRequiredMessage = "Dostępna jest nowa wersja Milta. Zaktualizuj aplikację, aby dalej z niej korzystać.",
    updateInstalledVersionLabel = "Zainstalowana",
    updateAvailableVersionLabel = "Dostępna",
    updateNowButton = "Aktualizuj",
    updateDataKeptNote = "Twoje trasy i dostawy zostaną zachowane.",
    updateSendingPendingOne = "Wysyłanie 1 dostawy zatwierdzonej offline…",
    updateSendingPendingMany = "Wysyłanie dostaw zatwierdzonych offline: {count}…",
)
